import { IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import { IcDeleteTrash, IcStylusNote } from '@/assets/images';
import { colors } from '@/theme/variables';
const actions = (
  onDelete?: (inspectionId?: string) => void,
  onEdit?: (inspectionId?: string) => void,
): Partial<GridColDef> => ({
  field: 'actions',
  headerName: 'Actions',
  width: 100,
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  renderCell: (params) => (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onEdit?.(params.row?._id);
        }}
      >
        <IcStylusNote />
      </IconButton>
      <IconButton
        sx={{ color: colors.error.main }}
        onClick={(e) => {
          e.stopPropagation();
          onDelete?.(params.row?._id);
        }}
      >
        <IcDeleteTrash />
      </IconButton>
    </>
  ),
});

export const buildingInspectionRecordsCols = (
  onDelete?: (inspectionId?: string) => void,
  onEdit?: (inspectionId?: string) => void,
) => {
  return {
    actions: () => actions(onDelete, onEdit),
  };
};
